<div class="relative flex w-full flex-col">
  <!-- Spinner -->
  @if (trialLoading || componentsLoading) {
    <div class="absolute z-10 flex h-full w-full items-center" style="background-color: #f3f6f7">
      @if (componentsLoading && !trialLoading) {
        <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
      }
    </div>
  }

  <!-- BVA Chart Menu -->
  <aux-trial-insights-finance-bva-chart-menu />

  <br />

  <aux-trial-insights-finance-comparing-budget />

  <div class="trial-insights-divider !m-0 !my-7 w-full"></div>

  <p class="font-bold">Trial to Date Insights</p>

  <div class="mt-4 grid grid-cols-3 gap-7">
    <div>
      <aux-trial-insights-finance-remaining-spend-over-time />
    </div>
    <div>
      <aux-trial-insights-finance-payment-milestones />
    </div>
    @if (showInvestigatorSpendCard$ | async) {
      <div>
        <aux-trial-insights-finance-enrolled-patients />
      </div>
    }
  </div>
</div>
